import React from 'react'
import FacilityForReservation from '../../../facilities/FacilityForReservation'
import {AdminReserveLocationState, ReservationInfo} from '../AdminReserveInterfaces'
import {PaymentInformation} from '../../ReserveFacilityModel'
import {Table, TableBody, TableCell, TableRow} from '@mui/material'
import {StyledTableCaption} from '../../../../styledComponents/adminPage/Table'
import {formatNumberWithCommas} from '../../../../formatters/formatNumberWithCommas'
import {createPaymentViewData} from '../AdminReserveHelper'
import lsHelper from '../AdminReserveLocationStateHelper'
import {BoldSpan} from '../../../../styledComponents/StyledSpan'
import {LeftMarginLink, MinimumWidthTableCell} from '../AdminReserveStyledComponent'
import {ReservationClass} from '../../ReservationInterfaces'
import {FixedWidthTableRowName} from './ARDetailsView'
import {NavigateFunction} from 'react-router-dom'


interface CommonProps {
    facilityData: FacilityForReservation
    reservationInfo: ReservationInfo
    paymentInfo: PaymentInformation
}

interface PropsForConfirm extends CommonProps {
    type: 'confirm'
    condominiumCd: string
    navigate: NavigateFunction
    locationState: AdminReserveLocationState
}

interface PropsForComplete extends CommonProps {
    type: 'complete'
}

type Props = PropsForConfirm | PropsForComplete

const AROptionView: React.FC<Props> = props => {
    const optionPaymentInfos = props.paymentInfo.items
        .filter(info => info.id !== null)

    const optionTotalCharge = optionPaymentInfos
        .map(paymentInfo => paymentInfo.charge || 0)
        .reduce((accumulator, charge) => accumulator + charge, 0)

    const optionPaymentTableData = createPaymentViewData(
        optionPaymentInfos,
        props.reservationInfo,
    )

    const classificationString = props.reservationInfo.classification

    return (<Table>
        <StyledTableCaption>
            オプション
            {
                props.type === 'confirm' &&
                <LeftMarginLink onClick={() => {
                    props.navigate(
                        `/admin/condominiums/${props.condominiumCd}/${classificationString}-reserve/select-option`,
                        {
                            replace: true,
                            state: lsHelper.toObject(props.locationState),
                        },
                    )
                }}>修正する</LeftMarginLink>
            }
        </StyledTableCaption>
        <TableBody>
            {
                optionPaymentTableData.map((info, index) => {
                    return (<TableRow key={index}>
                        <MinimumWidthTableCell>
                            {`${info.article}：${info.quantityWithUnit}`}
                        </MinimumWidthTableCell>
                        <MinimumWidthTableCell align={'right'}>
                            <BoldSpan>
                                {info.charge}
                            </BoldSpan>
                        </MinimumWidthTableCell>
                        {
                            props.reservationInfo.classification === ReservationClass.AGENT &&
                            <MinimumWidthTableCell>
                                <BoldSpan>
                                    {info.paymentType}
                                </BoldSpan>
                            </MinimumWidthTableCell>
                        }
                        <TableCell/>
                    </TableRow>)
                })
            }
            <TableRow>
                <FixedWidthTableRowName>オプション合計</FixedWidthTableRowName>
                <MinimumWidthTableCell>
                    <BoldSpan>
                        {
                            props.reservationInfo.classification === ReservationClass.AGENT
                                ? formatNumberWithCommas(optionTotalCharge)
                                : 0
                        }円
                    </BoldSpan>
                </MinimumWidthTableCell>
            </TableRow>
        </TableBody>
    </Table>)
}

export default AROptionView
